// extracted by mini-css-extract-plugin
export default {"wrapper":"Base_wrapper__iYI8k","main":"Base_main__tft5J"};